import { en } from './en';

export const es: Record<string, string> = {
  'delivery.title': "¿Dónde debemos entregar tu pedido?",
  'delivery.beforeSignup': "Comprueba la disponibilidad de entrega antes de introducir tus datos personales.",
  'delivery.country': "País de entrega",
  'delivery.choose': "Elige tu país de entrega",
  'delivery.availableTo': "Entrega en:",
  'delivery.blocked': "Algunos artículos no se pueden entregar en el país seleccionado. Tu carrito se ha conservado. Elige otro país de entrega o elimina los artículos no disponibles.",
  'delivery.backToCart': "Volver al carrito",
  'delivery.updateAddress': "Actualizar la dirección de entrega",
  'delivery.checkFailed': "No hemos podido comprobar la disponibilidad de entrega. Tu carrito se ha conservado. Inténtalo de nuevo.",
  'delivery.retry': "Intentar de nuevo",
  'delivery.checking': "Comprobando la disponibilidad de entrega…",
  ...en,
  'cart.adding': 'Añadiendo...',
  'cart.added': 'Añadido',
  'cart.addSuccess': 'Producto añadido al carrito',
  'cart.addFail': 'Error al añadir producto: {error}',
  'title.cart': 'Carrito',
  'title.catalog': 'Catálogo',
  'title.checkout': 'Pagar',
  'title.signup': 'Registrarse',
  'title.tickets': 'Atención al cliente',
  'title.discounts': 'Tu descuento personal',
  'auth.login': 'Iniciar sesión',
  'auth.loginModal.remindPassword': 'Olvidaste la contrasena?',
  'auth.logout': 'Cerrar sesión',
  'auth.signup': 'Registrarse',
  'auth.myAccount': 'Mi cuenta',
  'auth.orders': 'Mis pedidos',
  'auth.discount': '¡Tu descuento personal!',
  'discounts.title': 'Tu descuento personal',
  'discounts.description': 'Este descuento se aplica automáticamente a todos tus pedidos.',
  'auth.bonusAccount': 'Tu cuenta de bonificación',
  'auth.referral': 'Programa de referidos',
  'auth.subscriptions': 'Suscripciones',
  'title.subscriptions': 'Suscripciones',
  'subs.loading': 'Cargando...',
  'subs.loginRequired': 'Inicie sesión para gestionar sus suscripciones.',
  'subs.empty': 'No hay boletines disponibles.',
  'subs.instruction': 'Seleccione los boletines a los que desea suscribirse o darse de baja',
  'subs.list.1.name': 'Descuentos en productos',
  'subs.list.1.descr': 'Descuentos en productos de su interés. Frecuencia – mensual',
  'subs.list.2.name': 'Descuentos de cumpleaños',
  'subs.list.2.descr': 'Correo de cumpleaños con regalo. Frecuencia – anual',
  'subs.list.3.name': 'Aviso de reposición',
  'subs.list.3.descr': 'Notificación de reposición. Frecuencia – cada 2–3 meses',
  'subs.list.4.name': 'Noticias de la tienda',
  'subs.list.4.descr': 'Frecuencia – rara',
  'subs.success': 'Suscripciones actualizadas',
  'subs.failed': 'Error al actualizar.',
  'subs.updating': 'Actualizando...',
  'subs.update': 'Actualizar',
  'inline.loginLink': 'inicie sesion',
  'inline.loginRequiredPrefix': 'Por favor, ',
  'inline.loginRequiredSuffix': ' para ver esta pagina.',
  'subscribe.title': 'Suscríbete para recibir ofertas',
  'subscribe.subtitle': 'Recibe descuentos exclusivos y recordatorios de pedidos',
  'subscribe.cta': 'Suscribirse',
  'subscribe.emailLabel': 'Correo electronico',
  'subscribe.emailPlaceholder': 'tu@email.com',
  'subscribe.phoneLabel': 'Telefono',
  'subscribe.phonePlaceholder': '+34 600 000 000',
  'subscribe.consentLabel': 'Acepto recibir correos promocionales y recordatorios de pedidos',
  'subscribe.consentRequired': 'Acepta recibir correos',
  'subscribe.invalidEmail': 'Introduce un correo valido',
  'subscribe.success': 'Gracias. Te has suscrito.',
  'inline.subscriptionsAuthRedirect':
    'Las suscripciones al boletín solo están disponibles para clientes con sesión iniciada. Inicie sesión para continuar.',
  'auth.tickets': 'Atención al cliente',
  'auth.deleteAccount': 'Eliminar cuenta',
  'cartWidget.cart': 'Carrito',
  'cartWidget.viewCart': 'VER CARRITO',
  'cartWidget.shoppingCart': 'Carrito',
  'cartWidget.items': 'artículos',
  'title.checkoutQnr': 'Cuestionario médico',
  'title.checkoutConfirm': 'Confirmación del pedido',
  'cartPage.empty': 'Tu carrito está vacío',
  'cartPage.product': 'Producto',
  'cartPage.qty': 'Cant.',
  'cartPage.price': 'Precio',
  'cartPage.lineTotal': 'Total',
  'cartPage.loading': 'Cargando carrito...',
  'cartPage.startShopping': 'Empezar a comprar',
  'cartPage.recalculate': 'Recalcular',
  'cartPage.remove': 'Eliminar',
  'cartPage.free': 'Gratis',
  'cartPage.quickNotes': 'Notas rápidas:',
  'cartPage.note1': '1. El seguro de envio garantiza reembolso o reenvio.',
  'cartPage.note2': '2. El pago con Bitcoin da un 10% de descuento.',
  'cartPage.note3': '3. Introduce un cupon de descuento valido abajo.',
  'cartPage.note4': '4. Algunos descuentos se activan tras seleccionar el pago.',
  'cartPage.couponPlaceholder': 'Introduce un cupon aqui',
  'cartPage.couponLabel': 'Codigo de cupon',
  'cartPage.couponSubmit': 'Aplicar',
  'cartPage.couponInvalid': 'El cupon no es valido o ha caducado.',
  'cartPage.couponSuccess': 'El cupon se ha agregado correctamente.',
  'cartPage.couponNotApplied': 'El cupon no se aplico. No es valido, esta restringido para el metodo de pago seleccionado o no cumple los requisitos de la promocion.',
  'cartPage.couponCleared': 'El cupon se ha eliminado.',
  'cartPage.itemRemoved': 'Producto eliminado del carrito.',
  'cartPage.removeFailed': 'No se pudo eliminar el producto.',
  'cartPage.updateQtyFailed': 'No se pudo actualizar la cantidad.',
  'cartPage.qtyDecrease': 'Disminuir cantidad',
  'cartPage.qtyIncrease': 'Aumentar cantidad',
  'cartPage.maxPillsHint': 'Máx. {pills} pastillas ({packs} packs)',
  'cartPage.deliveryMethod': 'Metodo de entrega:',
  'cartPage.standard': 'Estandar',
  'cartPage.subtotal': 'Subtotal:',
  'cartPage.personalDiscount': 'Descuento personal:',
  'cartPage.bonusDiscount': 'Descuento de bono:',
  'cartPage.discountCoupon': 'Cupon de descuento:',
  'cartPage.clearCoupon': 'Quitar cupon',
  'cartPage.shippingCost': 'Costo de envio:',
  'cartPage.discounted': 'con descuento',
  'cartPage.freeShipping': 'envio gratis',
  'cartPage.shippingInsurance': 'Seguro de envio:',
  'cartPage.backToShopping': 'Volver a comprar',
  'shippingMethod.airmail_service': 'Servicio de correo aereo',
  'cartPage.total': 'Total:',
  'cartPage.checkout': 'Pagar',
  'stepper.cart': 'Carrito',
  'stepper.payment': 'Pago',
  'stepper.medical': 'Médico',
  'stepper.confirm': 'Confirmar',
  'miniCart.subtotal': 'Subtotal:',
  'miniCart.personalDiscount': 'Descuento personal:',
  'miniCart.bonusDiscount': 'Descuento de bono:',
  'miniCart.discountCoupon': 'Cupon de descuento:',
  'miniCart.shippingCost': 'Costo de envio:',
  'miniCart.freeShipping': 'envio gratis',
  'miniCart.shippingInsurance': 'Seguro de envio:',
  'miniCart.total': 'Total:',
  'miniCart.editCart': 'Editar carrito',
  'checkout.continue': 'Continuar',
  'confirm.title': 'Confirmación del pedido',
  'confirm.placeOrder': 'Realizar pedido',
  'qnr.title': 'Cuestionario médico',
  'confirm.retentionConsent': 'Acepto recibir correos promocionales y recordatorios sobre mis pedidos',
  'profile.updateProfile': 'Actualizar perfil',
  'telegram.title': 'Notificaciones de Telegram',
  'telegram.hint': 'Conecta Telegram para recibir actualizaciones de pedidos, alertas de seguimiento y chat de soporte en tu teléfono.',
  'telegram.orderFcTitle': 'Confirma tu pedido por Telegram',
  'telegram.orderFcIntro': 'Este pedido requiere una confirmación rápida de tus datos antes de que podamos enviar instrucciones de pago.',
  'telegram.orderFcFastest': 'Opción más rápida: conecta Telegram abajo. Después de hacer el pedido, el bot enviará una solicitud de confirmación.',
  'telegram.orderFcAlternatively': 'También puedes confirmar por teléfono o',
  'telegram.liveChat': 'chat en vivo',
  'telegram.orderFcReady': 'Podemos enviar la solicitud de confirmación a tu Telegram. Revisa el chat del bot.',
  'telegram.orderInfoTitle': 'Recibe actualizaciones en Telegram',
  'telegram.orderInfoIntro': 'Conecta nuestro bot de soporte para:',
  'telegram.orderInfoItem1': 'Estado del pedido y actualizaciones de envío',
  'telegram.orderInfoItem2': 'Eventos de seguimiento y alertas de entrega',
  'telegram.orderInfoItem3': 'Recordatorios de pago cuando sea necesario',
  'telegram.orderInfoItem4': 'Chat directo con soporte desde tu teléfono',
  'telegram.statusLoading': 'Comprobando conexión de Telegram…',
  'telegram.unavailable': 'La conexión de Telegram no está disponible ahora.',
  'telegram.connected': 'Telegram conectado',
  'telegram.connectedAt': 'Conectado',
  'telegram.boundFrom': 'Conectado desde',
  'telegram.connect': 'Conectar Telegram',
  'telegram.connecting': 'Conectando…',
  'telegram.linkReady': 'Abre Telegram y toca Start para terminar de vincular tu cuenta.',
  'telegram.openTelegram': 'Abrir Telegram',
  'telegram.copyLink': 'Copiar enlace',
  'telegram.copied': 'Copiado',
  'telegram.expiresMinutes': 'El enlace caduca en unos {minutes} minutos.',
  'telegram.notificationsTitle': 'Preferencias de notificación',
  'telegram.notificationsHint': 'La confirmación del pedido y el chat de soporte siempre funcionan. Elige alertas opcionales abajo.',
  'telegram.notificationsSaving': 'Guardando…',
  'telegram.notificationsSaveError': 'No se pudieron guardar los ajustes de notificación.',
  'telegram.disconnect': 'Desconectar Telegram',
  'telegram.disconnectConfirm': '¿Desconectar Telegram de tu cuenta? Puedes volver a conectarlo desde esta página.',
  'telegram.disconnectYes': 'Sí, desconectar',
  'telegram.disconnectCancel': 'Cancelar',
  'telegram.coupon.checkoutTitle': 'Conecta Telegram y ahorra un 20 %',
  'telegram.coupon.checkoutBody': 'Conéctalo ahora y aplicaremos un 20 % a este pedido.',
  'telegram.coupon.checkoutAction': 'Conectar Telegram y aplicar 20 %',
  'telegram.coupon.applied': 'Telegram conectado — se ha aplicado tu descuento del 20 %.',
  'telegram.coupon.replaceConfirm': 'Sustituir el cupón actual y aplicar 20 %',
  'telegram.coupon.active': 'Cupón de Telegram del {percent} % disponible.',
  'telegram.coupon.redeemed': 'Cupón de Telegram utilizado.',
  'telegram.coupon.expired': 'El cupón de Telegram ha caducado.',
  'telegram.disconnectError': 'No se pudo desconectar Telegram.',
  'telegram.pref.order_status.label': 'Actualizaciones del estado del pedido',
  'telegram.pref.order_status.description': 'Procesamiento, cancelación, rechazo y otros cambios de estado.',
  'telegram.pref.shipped.label': 'Envío y números de seguimiento',
  'telegram.pref.shipped.description': 'Cuando tu pedido se envía o se reenvía con un número de seguimiento.',
  'telegram.pref.tracking_updates.label': 'Eventos de seguimiento de entrega',
  'telegram.pref.tracking_updates.description': 'Actualizaciones del transportista, como en tránsito, en reparto o entregado.',
  'telegram.pref.payment.label': 'Recordatorios de pago',
  'telegram.pref.payment.description': 'Instrucciones de pago y avisos de pago insuficiente.',
  'telegram.pref.promotions.label': 'Promociones y ofertas',
  'telegram.pref.promotions.description': 'Descuentos opcionales y ofertas especiales.',
  'signup.createAccount': 'Crear cuenta',
  'login.title': 'Iniciar sesion',
  'login.loginLabel': 'Login',
  'login.loginPlaceholder': 'Correo electronico o usuario',
  'login.passwordLabel': 'Contrasena',
  'login.loginRequired': 'El login es obligatorio',
  'login.passwordRequired': 'La contrasena es obligatoria',
  'login.invalidCredentials': 'Correo electronico o contrasena invalidos.',
  'login.noAccount': 'No tienes cuenta?',
  'login.signupLink': 'Registrate',
  'login.submit': 'Iniciar sesion',
  'signup.personalInfo': 'Informacion personal',
  'signup.title': 'Tratamiento',
  'signup.mr': 'Sr.',
  'signup.mrs': 'Sra.',
  'signup.ms': 'Srta.',
  'signup.firstName': 'Nombre',
  'signup.lastName': 'Apellido',
  'signup.contactInfo': 'Informacion de contacto',
  'signup.email': 'Correo electronico',
  'signup.phone': 'Telefono',
  'signup.billingAddress': 'Direccion de facturacion',
  'signup.address': 'Direccion',
  'signup.zipcode': 'Codigo postal',
  'signup.city': 'Ciudad',
  'signup.country': 'Pais',
  'signup.state': 'Provincia',
  'signup.selectCountry': 'Seleccionar pais',
  'signup.stateProvince': 'Provincia / Estado',
  'signup.selectState': 'Seleccionar provincia',
  'signup.shippingAddress': 'Direccion de envio',
  'signup.sameAsBilling': 'Igual que la direccion de facturacion',
  'signup.privacyInfo': 'Informacion de privacidad',
  'signup.password': 'Contrasena',
  'signup.passwordHint': 'Minimo 5 caracteres. Debe ser diferente del usuario.',
  'signup.confirmPassword': 'Confirmar contrasena',
  'signup.agreeTermsTemplate': 'Estoy de acuerdo con los {terms} de la empresa.',
  'signup.agreeTermsLink': 'Terminos y condiciones',
  'signup.firstNameRequired': 'El nombre es obligatorio',
  'signup.lastNameRequired': 'El apellido es obligatorio',
  'signup.emailRequired': 'El correo electronico es obligatorio',
  'signup.emailInvalid': 'Formato de correo electronico invalido',
  'signup.phoneRequired': 'El telefono es obligatorio',
  'signup.addressRequired': 'La direccion es obligatoria',
  'signup.zipcodeRequired': 'El codigo postal es obligatorio',
  'signup.cityRequired': 'La ciudad es obligatoria',
  'signup.countryRequired': 'El pais es obligatorio',
  'signup.passwordRequired': 'La contrasena es obligatoria',
  'signup.passwordMinLength': 'La contrasena debe tener al menos 5 caracteres',
  'signup.passwordMismatch': 'Las contrasenas no coinciden',
  'signup.termsRequired': 'Debe aceptar los terminos y condiciones',
  'signup.failed': 'Registro fallido',
  'signup.creating': 'Creando cuenta...',
  'forgotPassword.emailLabel': 'Correo electronico',
  'forgotPassword.emailPlaceholder': 'tu@ejemplo.com',
  'forgotPassword.submit': 'Enviar codigo',
  'forgotPassword.success': 'Hemos enviado un codigo de 10 caracteres a tu correo.',
  'forgotPassword.successHint': 'Introduce el codigo en la siguiente pagina para establecer una nueva contrasena.',
  'forgotPassword.goToSetPassword': 'Introducir codigo y establecer contrasena',
  'forgotPassword.backToLogin': 'Volver al inicio de sesion',
  'forgotPassword.invalidEmail': 'Introduce un correo electronico valido',
  'resetPassword.emailLabel': 'Correo electronico',
  'resetPassword.resetCodeLabel': 'Codigo del correo',
  'resetPassword.resetCodePlaceholder': '10 caracteres',
  'resetPassword.resetCodeFormat': 'El codigo debe tener exactamente 10 letras o numeros',
  'resetPassword.newPasswordLabel': 'Nueva contrasena',
  'resetPassword.confirmLabel': 'Confirmar contrasena',
  'resetPassword.passwordPlaceholder': '••••••••',
  'resetPassword.passwordMin': 'La contrasena debe tener al menos 5 caracteres',
  'resetPassword.passwordMismatch': 'Las contrasenas no coinciden',
  'resetPassword.submit': 'Guardar',
  'resetPassword.success': 'Contrasena actualizada. Ahora puedes iniciar sesion.',
  'resetPassword.redirectHint': 'Redirigiendo...',
  'orders.title': 'Mis pedidos',
  'tickets.newMessage': 'Mensaje',
  'tickets.newUpload': 'Subir archivos (PDF, JPG, PNG, TXT)',
  'contact.formTitle': 'Envianos un mensaje',
  'contact.loginRequired': 'Inicia sesion para enviar un ticket de soporte.',
  'testimonials.customer': 'Cliente',
  'testimonials.loading': 'Cargando testimonios...',
  'testimonials.empty': 'Aun no hay testimonios.',
  'testimonials.loadError': 'No se pudieron cargar los testimonios. Intentalo mas tarde.',
  'testimonials.formTitle': 'Dejar un testimonio',
  'testimonials.namePlaceholder': 'Tu nombre',
  'testimonials.messagePlaceholder': 'Tu reseña',
  'testimonials.submitting': 'Enviando...',
  'testimonials.submit': 'Enviar reseña',
  'testimonials.submitError': 'No se pudo enviar el testimonio.',
  'testimonials.loginRequired': 'Inicia sesion para dejar un testimonio.',
  'testimonials.validationName': 'El nombre debe tener al menos 2 caracteres.',
  'testimonials.validationMessage': 'La reseña debe tener al menos 6 caracteres.',
  'testimonials.success': 'Gracias por tu reseña. Aparecera despues de la moderacion.',
  'contact.requestFrom': 'La solicitud se enviara desde',
  'contact.unknownUser': 'Usuario autenticado',
  'contact.subject': 'Asunto',
  'contact.subjectPlaceholder': 'Como podemos ayudarte?',
  'contact.message': 'Mensaje',
  'contact.messagePlaceholder': 'Describe tu problema...',
  'contact.send': 'Enviar mensaje',
  'contact.ticketsLoginRequired': 'Inicia sesion para ver y enviar tickets de soporte.',
  'chat.online': 'En linea',
  'chat.offline': 'Desconectado',
  'chat.coming_soon': 'El chat en vivo se esta configurando. Por ahora usa email o telefono.',
  'chat.offline_message': 'Nuestros operadores estan desconectados en este momento.',
  'chat.leave_message': 'Deja un mensaje y te responderemos.',
  'chat.leave_ticket': 'Dejar un ticket',
  'nav.login': 'Iniciar sesion',
  'nav.signup': 'Crear cuenta',
  'miniCart.deliveryMethod': 'Metodo de entrega',
  'month.1': 'Enero', 'month.2': 'Febrero', 'month.3': 'Marzo',
  'month.4': 'Abril', 'month.5': 'Mayo', 'month.6': 'Junio',
  'month.7': 'Julio', 'month.8': 'Agosto', 'month.9': 'Septiembre',
  'month.10': 'Octubre', 'month.11': 'Noviembre', 'month.12': 'Diciembre',
  'checkout.accountHint': 'Numero de cuenta: normalmente aparece antes del numero de cheque; la ubicacion varia.',
  'checkout.accountNumber': 'Numero de cuenta',
  'checkout.authLogin': 'Iniciar sesion',
  'checkout.authPrompt': 'Inicie sesion o registrese para continuar con la compra.',
  'checkout.authSignup': 'Registrarse',
  'checkout.backToConfirm': 'Volver a Confirmacion de pedido',
  'checkout.backToShop': 'Volver a la tienda',
  'checkout.bankName': 'Nombre del banco',
  'checkout.btcStep1': "Finaliza tu pedido para abrir la página de pago.",
  'checkout.btcStep2': "Envía el importe exacto en BTC a la dirección indicada, usando la red especificada.",
  'checkout.btcStep3': "Paga antes de que caduquen los datos de pago.",
  'checkout.btcOrderNote': "Usa estos datos de pago solo para este pedido. No necesitas confirmación telefónica.",
  'checkout.btcHelp': "Cómo comprar Bitcoin",
  "checkout.cryptoTitle": "Pagar con criptomonedas",
  "checkout.cryptoStep1": "Haz clic en Continuar.",
  "checkout.cryptoStep2": "Elige tu moneda y la red en la siguiente página.",
  "checkout.cryptoStep3": "Sigue las instrucciones para completar el pago.",
  "checkout.cryptoCoinsLabel": "Monedas disponibles",
  "checkout.cryptoCoins": "Ethereum · Litecoin · Bitcoin Cash · Dogecoin · Monero · Tron · XRP · Cardano · TON · BNB",
  "checkout.cryptoNetworks": "Elige Ethereum (ERC-20), Tron (TRC-20) o BNB Smart Chain (BEP-20).",
  "checkout.cryptoBitcoinTitle": "¿Quieres pagar con Bitcoin (BTC)?",
  "checkout.cryptoBitcoinNote": "Selecciona la opción de pago Bitcoin por separado al finalizar la compra.",
  'checkout.btcTitle': "Pagar con Bitcoin",
  'checkout.cartEmpty': 'Tu carrito esta vacio.',
  'checkout.ccNumber': 'Numero de tarjeta de credito (sin espacios ni guiones)',
  'checkout.ccType': 'Tipo de tarjeta de credito',
  'checkout.checkNumber': 'Numero de cheque',
  'checkout.cvv': 'CVV2',
  'checkout.error': 'Se produjo un error',
  'checkout.expDate': 'Fecha de expiracion',
  'checkout.loading': 'Cargando proceso de compra...',
  'checkout.noPayments': 'Lamentablemente, no hay pagos disponibles para realizar el pago. Por favor contacte con el departamento de ventas o soporte.',
  'checkout.paymentFailed': 'No se pudo establecer el metodo de pago',
  'checkout.processing': 'Procesando...',
  'checkout.routingHint': 'Numero de ruta (codigo ABA): generalmente 9 digitos en su cheque.',
  'checkout.routingNumber': 'Numero de ruta (codigo ABA)',
  'checkout.selectPayment': 'Seleccione un metodo de pago',
  'contact.email': 'Correo electronico',
  'contact.hours': 'Horas de trabajo',
  'contact.previewHours': 'Lun-Vie 9:00-18:00',
  'contact.support247': 'Soporte 24/7',
  'contact.live_chat': 'Chat en vivo',
  'contact.open_ticket': 'Abrir un ticket',
  'contact.phone': 'Telefono',
  'contact.start_chat': 'Iniciar chat',
  'contact.tickets_desc': 'Tiene alguna pregunta? Abra un ticket de soporte y nos comunicaremos con usted.',
  'contact.title': 'Contactenos',
  'contact.unavailable': 'La informacion de contacto no esta disponible.',
  'deleteAccount.attention': 'Atencion!',
  'deleteAccount.failed': 'La solicitud fallo. Por favor intentalo de nuevo.',
  'deleteAccount.password': 'Contrasena',
  'deleteAccount.passwordRequired': 'Se requiere contrasena.',
  'deleteAccount.reason': 'Razon',
  'deleteAccount.reasonHint': 'Por favor, comparta el motivo de su salida. Tus comentarios nos ayudan a mejorar.',
  'deleteAccount.reasonRequired': 'Se requiere razon.',
  'deleteAccount.rule1': 'No deberias tener ninguna devolucion de cargo en tu historial.',
  'deleteAccount.rule2': 'Deben pasar al menos 21 dias despues de su ultimo pedido exitoso.',
  'deleteAccount.rules': 'Reglas de eliminacion de cuenta:',
  'deleteAccount.safetyInfo': 'Su privacidad nos importa. Puede eliminar permanentemente su cuenta y el historial relacionado en cualquier momento.',
  'deleteAccount.submit': 'Enviar',
  'deleteAccount.success': 'Cuenta eliminada exitosamente.',
  'deleteAccount.thanks': 'Gracias por elegir nuestro servicio.',
  'deleteAccount.warning': 'Si posteriormente se recibe una devolucion de cargo para cualquier pedido, su cuenta puede restaurarse para procesar ese caso. Si tiene preguntas, comuniquese con el soporte 24 horas al dia, 7 dias a la semana.',
  'profile.address': 'Direccion',
  'profile.addressRequired': 'Se requiere direccion',
  'profile.billingAddress': 'Direccion de facturacion',
  'profile.changePassword': 'Cambiar la contrasena',
  'profile.city': 'Ciudad',
  'profile.cityRequired': 'Se requiere ciudad',
  'profile.confirmPassword': 'Confirmar contrasena',
  'profile.country': 'Pais',
  'profile.countryRequired': 'Se requiere pais',
  'profile.email': 'Correo electronico',
  'profile.emailInvalid': 'Formato de correo electronico no valido',
  'profile.emailRequired': 'Se requiere correo electronico',
  'profile.firstName': 'Nombre',
  'profile.firstNameRequired': 'El nombre es obligatorio',
  'profile.lastName': 'Apellido',
  'profile.lastNameRequired': 'Se requiere apellido',
  'profile.loadFailed': 'No se pudieron cargar los datos del perfil',
  'profile.loading': 'Cargando perfil...',
  'profile.mr': 'Sr.',
  'profile.mrs': 'Sra.',
  'profile.ms': 'Sra.',
  'profile.newPassword': 'Nueva contrasena',
  'profile.passwordHint': 'Dejelo en blanco si no desea cambiar su contrasena.',
  'profile.passwordMinLength': 'La contrasena debe tener al menos 5 caracteres.',
  'profile.passwordMismatch': 'Las contrasenas no coinciden',
  'profile.personalInfo': 'Informacion personal',
  'profile.phone': 'Telefono',
  'profile.phoneRequired': 'Se requiere telefono',
  'profile.sameAsBilling': 'Igual que la direccion de facturacion',
  'profile.saving': 'Guardando...',
  'profile.selectCountry': 'Seleccionar pais',
  'profile.selectState': 'Seleccionar estado',
  'profile.shippingAddress': 'Direccion de envio',
  'profile.state': 'Estado',
  'profile.stateProvince': 'Estado / Provincia',
  'profile.title': 'Titulo',
  'profile.updateFailed': 'La actualizacion fallo',
  'profile.updateSuccess': 'Perfil actualizado exitosamente',
  'profile.zipcode': 'Codigo postal',
  'profile.zipcodeRequired': 'Se requiere codigo postal',
  'select.noResults': 'No se encontraron resultados',
  'select.placeholder': 'Seleccionar...',
  'select.search': 'Buscar...',
  'tickets.activationFailed': 'No se pudo enviar el correo electronico de activacion',
  'tickets.activationSuccess': 'Correo electronico de activacion enviado correctamente',
  'tickets.authInstructions': 'Si desea activarlo, haga clic en el boton a continuacion y le enviaremos las instrucciones por correo electronico.',
  'tickets.authNotActivated': 'El sistema de tickets aun no se ha activado para su cuenta.',
  'tickets.backToTickets': 'Volver a tickets',
  'tickets.createSuccess': 'Ticket creado exitosamente',
  'tickets.date': 'Fecha',
  'tickets.dateLabel': 'Fecha:',
  'tickets.detailLoading': 'Cargando ticket...',
  'tickets.empty': 'No se han encontrado tickets por el momento. Utilice \"Abrir nuevo ticket\" para hacer una pregunta',
  'tickets.fileLimit': 'Seleccione hasta 3 archivos.',
  'tickets.lastReply': 'Ultima respuesta',
  'tickets.loading': 'Cargando tickets...',
  'tickets.loadingMore': 'Cargando mas...',
  'tickets.message': 'Mensaje',
  'tickets.newSubject': 'Asunto',
  'tickets.newTicketTitle': 'Abrir nuevo ticket',
  'tickets.noMessages': 'No se encontraron mensajes.',
  'tickets.messagesHeading': 'Mensajes',
  'tickets.messageFromSupport': 'Soporte',
  'tickets.messageFromYou': 'Usted',
  'tickets.replyHeading': 'Responder',
  'tickets.attachFiles': 'Adjuntar archivos',
  'tickets.filesCount': '{count} archivo(s)',
  'tickets.notActivated': 'Sistema de tickets no activado para su cuenta.',
  'tickets.openNew': 'Abrir nuevo ticket',
  'tickets.refresh': 'Actualizar',
  'tickets.resolve': 'Resolver ticket',
  'tickets.resolveConfirm': 'Esta seguro de que desea resolver este ticket?',
  'tickets.sendActivation': 'Enviar correo electronico de activacion',
  'tickets.sendReply': 'Enviar respuesta',
  'tickets.status': 'Estado',
  'tickets.statusAwaitingAgent': 'Esperando agente',
  'tickets.statusAwaitingUser': 'Esperando usuario',
  'tickets.statusLabel': 'Estado:',
  'tickets.statusPending': 'Pendiente',
  'tickets.statusResolved': 'Resuelto',
  'tickets.subject': 'Asunto',
  'tickets.submitTicket': 'Enviar ticket',
  'tickets.title': 'Tickets de soporte',
  'tickets.uploadFiles': 'Cargar archivos (PDF, JPG, PNG, TXT)',
  'close': 'Cerrar',
  'loading': 'Cargando...',
  'yes': 'Sí',
  'no': 'No',
  'tickets.unavailable': 'Los tickets de soporte no están disponibles temporalmente. Inténtelo más tarde o contacte al soporte por email si es urgente.',
  'api.genericError': 'Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde.',
  'api.networkError': 'Servicio temporalmente no disponible. Compruebe su conexión.',
  'api.error.10503': 'Servicio no disponible',
  'api.error.40001': 'La autenticación del cliente ha fallado',
  'api.error.40004': 'La validación de datos del cliente ha fallado',
  'api.error.40008': 'Este inicio de sesión ya existe',
  'api.error.40009': 'Este correo electrónico ya existe',
  'api.error.40021': 'La cuenta del cliente ya existe',
  'api.error.40022': 'Cliente no encontrado',
  'api.error.400014': 'El cupón no es válido',
  'api.error.50001': 'La verificación antifraude ha fallado',
  'api.error.50002': 'La cuenta tiene pedidos pendientes y no puede eliminarse.',
  'api.error.60001': 'Este producto no está disponible en este momento.',
  'geo.soft_notice': 'This product has delivery region limits. Final availability is confirmed after sign-in using your shipping address.',
  'api.error.60101': 'Puede añadir hasta {limit} productos diferentes por pedido.',
  'api.error.60102': 'La cantidad máxima para este producto es {limit}.',
  'api.error.60103': 'El número máximo de packs para este producto es {limit}.',
  'unsubscribe.processing': 'Procesando…',
  'unsubscribe.success': 'Ha sido dado de baja de los correos de marketing de {shop_name}.',
  'unsubscribe.shop': 'Tienda',
  'unsubscribe.invalidLink': 'Enlace no válido o caducado.',
  'unsubscribe.error': 'Se ha producido un error.',

  'title.orderReturn': 'Estado del pago',
  'orderReturn.successTitle': '¡Gracias!',
  'orderReturn.successLead': 'Hemos recibido tu pago.',
  'orderReturn.successHint': 'Te hemos enviado un correo de confirmación. Las actualizaciones de envío llegarán pronto.',
  'orderReturn.cancelTitle': 'Pago cancelado',
  'orderReturn.cancelLead': 'No se ha cobrado este pedido.',
  'orderReturn.cancelHint': 'Tras el checkout el carrito queda vacío. Usa los detalles del pedido o « Intentar de nuevo » abajo.',
  'orderReturn.failureTitle': 'Pago fallido',
  'orderReturn.failureLead': 'No pudimos completar el pago de este pedido.',
  'orderReturn.failureHint': 'El carrito se vació al hacer el pedido. Vuelve a intentarlo, revisa el pedido o contacta con soporte.',
  'orderReturn.btnDetails': 'Ver detalles del pedido',
  'orderReturn.btnSignIn': 'Inicia sesión para ver los detalles',
  'orderReturn.btnContinueShopping': 'Seguir comprando',
  'orderReturn.btnContactSupport': 'Contactar soporte',
  'orderReturn.btnTryAgain': 'Intentar de nuevo',
  'confirm.loadFailed': 'No se pudieron cargar los detalles del pedido',
  'confirm.shippingAddress': 'Dirección de envío',
  'confirm.edit': 'Editar',
  'confirm.paymentMethod': 'Método de pago',
  'confirm.notSelected': 'No seleccionado',
  'confirm.shippingNote': '*El envío US2US suele tardar 3 días hábiles tras el despacho (hasta 5 días hábiles).',
  'confirm.overseasShippingNote': '*El envío overseas suele tardar 14-28 días hábiles para productos de la UE e India.',
  'confirm.manufacturerNote': '*Tenemos varios fabricantes de este producto. Si el fabricante que ordenó no tiene stock actualmente, nos comunicaremos con usted y ofreceremos una alternativa.',
  'confirm.agreePolicy': 'Declaro que acepto la Política de reembolso y la Política de contracargos',
  'confirm.back': 'Atrás',
  'confirm.placing': 'Realizando pedido...',
  'confirm.previewModeNotice': 'Modo de vista previa: los pedidos reales están deshabilitados.',
  'confirm.success': 'Pedido realizado correctamente.',
  'confirm.invalidResponse': 'Respuesta de pedido inválida',
  'confirm.failed': 'No se pudo realizar el pedido',
  'qnr.loading': 'Cargando cuestionario...',
  'qnr.loadFailed': 'No se pudo cargar el cuestionario',
  'qnr.retry': 'Reintentar',
  'qnr.intro': 'Complete este formulario para solicitar la receta del medicamento que pidió. Es la misma información que se le pediría si visitara una clínica o un médico.',
  'qnr.general': 'Información general',
  'qnr.dob': 'Fecha de nacimiento del paciente',
  'qnr.day': 'Día',
  'qnr.month': 'Mes',
  'qnr.year': 'Año',
  'qnr.dobRequired': 'La fecha de nacimiento es obligatoria',
  'qnr.gender': 'Género',
  'qnr.selectPlaceholder': 'Seleccionar...',
  'qnr.genderRequired': 'El género es obligatorio',
  'qnr.height': 'Altura del paciente',
  'qnr.heightRequired': 'La altura es obligatoria',
  'qnr.weight': 'Peso del paciente',
  'qnr.weightRequired': 'El peso es obligatorio',
  'qnr.medicalHistory': 'Historial médico',
  'qnr.disorderQuestion': '¿Cuál es el trastorno o la queja por la que solicita este medicamento?',
  'qnr.conditionRequired': 'La condición médica es obligatoria',
  'qnr.otherDisease': '¿Tiene alguna otra enfermedad, trastorno o problema médico?',
  'qnr.yesNo': 'Responda sí o no',
  'qnr.specifyOther': 'Si la respuesta es sí, especifique',
  'qnr.specifyRequired': 'Especifique otros problemas médicos',
  'qnr.confirmations': 'Confirmaciones',
  'qnr.declaration': 'Declaro que la información proporcionada es completa y sin reservas...',
  'qnr.declarationRequired': 'La declaración es obligatoria',
  'qnr.responsibility': 'Declaración de responsabilidad del cliente',
  'qnr.responsibilityRequired': 'La declaración de responsabilidad es obligatoria',
  'qnr.consent': 'Declaro que acepto el Acuerdo de consentimiento informado',
  'qnr.consentRequired': 'El acuerdo de consentimiento es obligatorio',
  'qnr.yes': 'Sí',
  'qnr.no': 'No',
  'qnr.back': 'Atrás',
  'qnr.saving': 'Guardando...',
  'qnr.continue': 'Continuar',
  'qnr.saved': 'Cuestionario médico guardado',
  'qnr.saveFailed': 'No se pudo guardar el cuestionario',
  'validate.ccEmpty': 'El número de tarjeta no puede estar vacío',
  'validate.ccInvalid': 'El número de tarjeta no es válido',
  'validate.ccAmex': 'El número de tarjeta Amex debe ser válido',
  'validate.ccMaster': 'El número de MasterCard debe ser válido',
  'validate.ccVisa': 'El número de Visa debe ser válido',
  'validate.ccTypeEmpty': 'El tipo de tarjeta no puede estar vacío',
  'validate.cvvDigits': 'El CVV2 debe tener 3-4 dígitos',
  'validate.cvvEmpty': 'El CVV2 no puede estar vacío',
  'validate.bankEmpty': 'El nombre del banco no puede estar vacío',
  'validate.bankLength': 'El nombre del banco debe tener entre 1 y 32 caracteres',
  'validate.chequeEmpty': 'El número de cheque no puede estar vacío',
  'validate.chequeDigits': 'El número de cheque solo puede contener dígitos',
  'validate.chequeLength': 'El número de cheque debe tener entre 1 y 16 caracteres',
  'validate.routingEmpty': 'El número de ruta no puede estar vacío',
  'validate.routingDigits': 'El número de ruta solo puede contener dígitos',
  'validate.routingLength': 'El número de ruta debe tener entre 1 y 16 caracteres',
  'validate.accountEmpty': 'El número de cuenta no puede estar vacío',
  'validate.accountDigits': 'El número de cuenta solo puede contener dígitos',
  'validate.accountLength': 'El número de cuenta debe tener entre 1 y 16 caracteres',
  'paymentMethod.credit_card_amex': 'Tarjeta de crédito (Amex)',
  'paymentMethod.credit_card': 'Tarjeta de crédito',
  'paymentMethod.echeque': 'Cheque electrónico',
  'paymentMethod.bitcoin': 'Bitcoin',
  'paymentCard.amex': 'Amex',
  'paymentCard.mc': 'MasterCard',
  'paymentCard.visa': 'Visa',
  'orderSuccess.placedSuccess': 'Tu pedido se ha realizado correctamente.',
  'orderSuccess.thanks': 'Gracias. Tu pedido se ha realizado.',
  'orderSuccess.orderId': 'ID del pedido:',
  'orderSuccess.description': 'Recibirás una confirmación del pedido por correo electrónico. Procesaremos tu pedido lo antes posible.',
  'orderSuccess.orderDetails': 'Detalles del pedido',
  'orderSuccess.viewOrders': 'Ver mis pedidos',
  'orderSuccess.close': 'Volver a la tienda',
  'pagination.label': 'Paginación',
  'pagination.first': 'Primera',
  'pagination.previous': 'Anterior',
  'pagination.next': 'Siguiente',
  'pagination.last': 'Última',

  // ── OrdersView (list/filter) ──
  'orders.loading': 'Cargando pedidos...',
  'orders.loadFailed': 'No se pudieron cargar los pedidos',
  'orders.empty': 'Aún no hay pedidos.',
  'orders.filter': 'Filtro:',
  'orders.allTime': 'Todo el tiempo',
  'orders.thisMonth': 'Este mes',
  'orders.thisWeek': 'Esta semana',
  'orders.today': 'Hoy',

  // ── BonusAccountPage ──
  'referralProgram.headline': 'Invita a un amigo: recibe un {friend} % y tú un {reward} %.',
  'referralProgram.intro': 'Comparte tu enlace personal. Cuando tu amigo reciba su primer pedido, aparecerá aquí un cupón independiente del {reward} %.',
  'referralProgram.how': 'Tu amigo recibe un {friend} % en su primer pedido. Tú recibes un cupón del {reward} % válido durante {months} meses después del envío.',
  'referralProgram.rulesTitle': 'Reglas de los cupones',
  'referralProgram.ruleSeparate': 'Recibes un cupón independiente por cada nuevo cliente referido.',
  'referralProgram.ruleOnePerOrder': 'Solo se puede aplicar un cupón por pedido.',
  'referralProgram.ruleNoLimit': 'El descuento del {reward} % no tiene límite máximo.',
  'referralProgram.couponsTitle': 'Tus cupones de referidos',
  'referralProgram.noCoupons': 'Todavía no tienes cupones de referidos.',
  'referralProgram.apply': 'Aplicar al carrito',
  'referralProgram.applying': 'Aplicando…',
  'referralProgram.expires': 'Caduca',
  'referralProgram.status.active': 'Activo',
  'referralProgram.status.redeemed': 'Usado',
  'referralProgram.status.expired': 'Caducado',
  'referralProgram.status.revoked': 'No disponible',
  'referralShare.button': 'Compartir',
  'referralShare.signIn': 'Inicia sesión o crea una cuenta para compartir tu enlace de referido personal.',
  'referralShare.signInButton': 'Iniciar sesión para compartir',
  'referralShare.copied': 'Enlace de referido copiado.',
  'referralShare.failed': 'No se pudo compartir ni copiar tu enlace de referido.',
  'referralShare.ready': 'Tu enlace está listo. Pulsa Compartir para enviarlo.',
  'referralCoupon.loginRequired': 'Inicia sesión para aplicar tu cupón de descuento.',
  'referralCoupon.applied': 'Se ha aplicado tu cupón de descuento del {reward} %.',
  'referralCoupon.appliedGeneric': 'Se ha aplicado tu cupón de descuento.',
  'referralCoupon.applyFailed': 'No pudimos aplicar este cupón. Inténtalo de nuevo desde tu cuenta.',
  'bonus.headline': 'Gana bonos de por vida con nuestro programa de referidos',
  'bonus.intro': 'Invita a amigos y gana bonos por sus compras. Puedes usar tu saldo de bonos para cubrir hasta el 50% de tu próximo pedido.',
  'bonus.howTitle': '¿Cómo funciona?',
  'bonus.howDesc': 'Comparte tu enlace o código de referido personal. Cuando un nuevo cliente compra con él, recibes el 15% del valor enviado como crédito de bono.',
  'bonus.subsequent': 'En cada pedido enviado futuro, recibes un 5% adicional.',
  'bonus.friendBenefits': '¿Cuáles son los beneficios para tu amigo?',
  'bonus.friendDiscount': 'Tu amigo obtiene un 20% de descuento en su primer pedido usando tu enlace o código.',
  'bonus.whyGreat': 'Por qué esto es genial para ti:',
  'bonus.benefit1': 'Usa bonos para cubrir hasta el 50% del total del pedido.',
  'bonus.benefit2': 'Recibe una notificación cada vez que se acredite tu saldo de bonos.',
  'bonus.benefit3': 'Gana también con subreferidos: 10% de los bonos que gane tu referido directo.',
  'bonus.startSharing': 'Comparte tu enlace de referido y empieza a ganar hoy.',
  'bonus.refLinkLabel': 'Tu enlace de referido (clic para copiar)',
  'bonus.copy': 'Copiar al portapapeles',
  'bonus.copied': 'Copiado',
  'bonus.copyFailed': 'Error al copiar',
  'bonus.refCodeIntro': 'Alternativamente, puedes compartir tu código único, que tus referidos pueden usar como cupón.',
  'bonus.transactions': 'Transacciones de la cuenta de bonos',
  'bonus.referralTree': 'Árbol de referidos',

  // ── BonusTransactionsPage ──
  'bonusTx.loading': 'Cargando...',
  'bonusTx.back': 'Volver',
  'bonusTx.balance': 'Cuenta de bonos:',
  'bonusTx.date': 'Fecha',
  'bonusTx.addedBonus': 'Bono añadido',
  'bonusTx.usedBonus': 'Bono usado',
  'bonusTx.type': 'Tipo',
  'bonusTx.empty': 'Aún no hay transacciones en tu cuenta de bonos.',
  'bonusTx.typeM': 'Bono por compra de referido',
  'bonusTx.typeC': 'Bono por compra de subreferido',
  'bonusTx.typeO': 'Bono aplicado para pagar tu pedido',
  'bonusTx.typeOOrder': 'Bono aplicado para pagar tu pedido nº {orderId}',
  'bonusTx.typeP': 'Regalo',
  'bonusTx.typeW': 'Retiro',

  // ── ReferralPage ──
  'referral.back': 'Volver',
  'referral.loading': 'Cargando...',
  'referral.empty': 'No hay datos de referidos disponibles.',
  'referral.description': 'Esta sección muestra el árbol de referidos a partir de ti. También muestra estadísticas de bonos de un referido concreto y su rama. Nuestro sistema multinivel te permite ganar el 10% de los bonos de referido de los referidos hechos por tus referidos directos.',
  'referral.referral': 'Referido',
  'referral.bonuses': 'Bonos de referido',
  'referral.subBonuses': 'Bonos de subreferido',
  'referral.level': 'nivel:',
  'referral.bonusesNote': 'Bonos de referido — bonos de compras hechas por tus referidos directos.',
  'referral.subBonusesNote': 'Bonos de subreferido — bonos de los referidos de tus referidos.',
};
